import React from 'react';

import { fg } from '@townsquare/stat-sig/gate';

import { LoadingSkeleton as Styles } from './styles';
import { LoadingSkeleton as Compiled } from './styles.compiled';
import { type Props } from './types';

const LoadingSkeleton = fg('townsquare_compiled_css_migration_goals') ? Compiled : Styles;

export const SquareLoadingSkeleton = ({
	sideLengthPx,
	...props
}: Omit<Props, 'height' | 'width'> & { sideLengthPx: number }): React.JSX.Element => (
	<LoadingSkeleton height={`${sideLengthPx}px`} width={`${sideLengthPx}px`} {...props} />
);

export const AvatarLoadingSkeleton = ({
	sideLengthPx,
	...props
}: Omit<Props, 'height' | 'width'> & { sideLengthPx: number }): React.JSX.Element => (
	<LoadingSkeleton
		height={`${sideLengthPx}px`}
		width={`${sideLengthPx}px`}
		borderRadius="50%"
		{...props}
	/>
);

export const PhaseLozengeLoadingSkeleton = (props: Props): React.JSX.Element => (
	<LoadingSkeleton height={props.height || '24px'} width={props.width || '70px'} {...props} />
);
